import { useCallback } from 'react';
import { searchKpisByTag } from '../utils/kpi'

export const useKpiSearcherByTag = () => useCallback(searchKpisByTag, [])
